import { render, staticRenderFns } from "./congrats-component.vue?vue&type=template&id=5ae8220e&scoped=true&"
import script from "./congrats-component.vue?vue&type=script&lang=ts&"
export * from "./congrats-component.vue?vue&type=script&lang=ts&"
import style0 from "./congrats-component.vue?vue&type=style&index=0&id=5ae8220e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae8220e",
  null
  
)

export default component.exports